import { render, staticRenderFns } from "./TbcGetOtp.vue?vue&type=template&id=994559dc&"
import script from "./TbcGetOtp.vue?vue&type=script&lang=js&"
export * from "./TbcGetOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports